<header>
  <nav class="navbar navbar-expand-lg navbar-dark" *ngIf="isLoggedIn">
    <a class="navbar-brand ml-4" href="/">
      <img class="mb-0" src="assets/icons/company_logo.png" alt="" style="width: 200px" />
    </a>

    <div class="collapse navbar-collapse justify-content-end">
      <!-- <div id="search-box-nav-container" class="p-2">
          <form class="d-flex search" action="search" method="get">
              <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" name="q">
              <button class="btn" type="submit">
                  <i class="bi bi-search"></i>
              </button>
          </form>
      </div> -->
      <ul class="navbar-nav">
        <li class="nav-item" *ngIf="!isDirEndUser">
          <button
            type="button"
            class="btn btn-secondary btn-ls-cancel mt-2 btn-ls-featured-action"
            onclick="window.open('https://lsretail.atlassian.net/servicedesk/customer/portals','_blank');"
          >
            Request support
          </button>
        </li>

        <!-- <li class="nav-item">
        <button type="button" class="btn btn-mint mt-2 btn-ls-featured-action"
          onclick="window.open('https://www.lsretail.com/contact-us','_blank');">Contact us</button>
      </li> -->

        <li class="nav-item p-2 header-user" *ngIf="isLoggedIn">
          <a class="member-profile-link" (mouseenter)="oppartners.toggle($event)">{{ partnerName }}</a>
          <p-overlayPanel #oppartners>
            <ng-template pTemplate>
              <div>
                <!-- <div *ngIf="isTestingPartner"> -->
                <a
                  *ngxPermissionsOnly="[constants.Role.BCADMIN, constants.Role.BCSUPER, constants.Role.BCVIEWER]"
                  routerLink="/user-management"
                  style="color: black; text-align: center"
                  (click)="oppartners.hide()"
                  >User Management</a
                >
                <!-- <div *ngIf="partners.length != 1"> -->
                <div>
                  <hr />
                  <a
                    href="javascript:void(0)"
                    (click)="changeAccountClicked($event); oppartners.hide()"
                    style="color: black"
                    id="logout"
                    >Change account</a
                  >
                </div>
              </div>

              <!-- <div *ngxPermissionsExcept="[constants.Role.BCADMIN]">
              <div *ngFor="let partner of partners">
                <hr />
                <a
                  style="color: black; cursor: pointer"
                  (click)="partnerSelected($event, partner); oppartners.hide()"
                  >{{ partner.name }}</a
                >
              </div>
            </div> -->
            </ng-template>
          </p-overlayPanel>
        </li>

        <li class="nav-item p-2 header-user" *ngIf="isLoggedIn">
          <span class="member-profile-link">{{ userName }}</span>
          <span class="member-profile-link" title="Log off" (click)="logoutClicked($event)">
            <i
              class="bi bi-box-arrow-right"
              style="padding: 0 15px; color: #ee5455; cursor: pointer; font-size: 15px"
            ></i>
          </span>
        </li>
      </ul>
    </div>
    <div class="sidebar_toggle">
      <button class="btn" style="cursor: pointer; color: white" (click)="toggleNavbarCollapsing()" type="button">
        <i class="pi pi-list"></i>
      </button>
    </div>
  </nav>
</header>
